/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface CallbackMeasurementCompleteGet$Params {

/**
 * Base64 encoded measurement results
 */
  results?: string;

/**
 * Error code if measurement failed
 */
  error?: string;

/**
 * The unique identifier of the scan session
 */
  sessionId?: string;

/**
 * Base64 encoded additional details
 */
  details?: string;
}

export function callbackMeasurementCompleteGet(http: HttpClient, rootUrl: string, params?: CallbackMeasurementCompleteGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, callbackMeasurementCompleteGet.PATH, 'get');
  if (params) {
    rb.query('results', params.results, {});
    rb.query('error', params.error, {});
    rb.query('sessionId', params.sessionId, {});
    rb.query('details', params.details, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as VivaLiteScanStrictHttpResponse<void>;
    })
  );
}

callbackMeasurementCompleteGet.PATH = '/Callback/MeasurementComplete';
